var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-button-wrapper",style:({
    position: 'absolute',
    left: 0,
    top: 0,
    transform: ("translate(" + _vm.x + "px, " + _vm.y + "px)"),
  })},[_c('v-btn',{staticClass:"button",attrs:{"icon":"","small":"","outlined":"","color":_vm.color},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }